import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'
import type { RecipientListId } from 'types/list'
import { deleteEmailGroup } from '@disco/state-management/actions/EmailGroupActions'
import DocumentHeadTags from 'components/document-head-tags'
import ModalDialog from 'components/ui/modal-dialog'

type OwnProps = {
  params: {
    listId?: string
    deleteListId?: string
  }
  navigate: NavigateFunction
  onClose: () => unknown
}

const mapStateToProps = null
const mapDispatchToProps = {
  deleteEmailGroup,
}

// Define connector
const connector = connect(mapStateToProps, mapDispatchToProps)

// Infer props type
type PropsFromRedux = ConnectedProps<typeof connector>

// Component props = Redux props + own props
type Props = PropsFromRedux & OwnProps

class ContactListDelete extends React.Component<Props> {
  _onClose = () => {
    if (this.props.params.listId) {
      this.props.navigate(`/lists/${this.props.params.listId}`)
    } else {
      this.props.navigate('/lists')
    }
  }
  _onDeleteList = () => {
    const listId = this.props.params.deleteListId || this.props.params.listId
    this.props.deleteEmailGroup({
      id: parseInt(listId),
      name: '',
      recipients: [],
    } as any)
    this.props.navigate(`/lists`)
  }

  render() {
    const title = 'Delete List'
    return (
      <div>
        <DocumentHeadTags title={`${title} | DISCO`} />
        <ModalDialog
          title="Delete list"
          primaryAction={{
            caption: 'Delete',
            onClick: this._onDeleteList,
          }}
          status="danger"
          onCancel={this._onClose}
        >
          Are you sure you want to permanently delete this list? This can’t be
          undone.
        </ModalDialog>
      </div>
    )
  }
}

const ConnectedContactListDelete = connector(ContactListDelete)

function ContactListDeleteWithRouter(props: any) {
  const navigate = useNavigate()
  const params = useParams<{ listId?: string; deleteListId?: string }>()
  return (
    <ConnectedContactListDelete
      {...props}
      navigate={navigate}
      params={params}
    />
  )
}

export default ContactListDeleteWithRouter
